// src/components/ui/StatusBadge/StatusBadge.jsx
import PropTypes from "prop-types"
import { Badge } from "../Badge/Badge"
import { cn } from "../../../lib/utils"

const STATUS_MAP = {
  active: { label: "Active", variant: "status-success" },
  inactive: { label: "Inactive", variant: "status-neutral" },
  pending: { label: "Pending", variant: "status-warning" },
  approved: { label: "Approved", variant: "status-success" },
  rejected: { label: "Rejected", variant: "status-danger" },
  submitted: { label: "Submitted", variant: "status-info" },
  cancelled: { label: "Cancelled", variant: "status-neutral" },
}

export default function StatusBadge({ status, label, className }) {
  const config = STATUS_MAP[status] || {
    label: status,
    variant: "status-neutral",
  }
  const displayLabel = label || config.label

  return (
    <Badge variant={config.variant} className={cn("gap-[5px]", className)}>
      <span
        data-slot="dot"
        className="size-[5px] rounded-full bg-current shrink-0"
        aria-hidden="true"
      />
      {displayLabel}
    </Badge>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
}
